import { render, staticRenderFns } from "./IconTikTokLight.vue?vue&type=template&id=0b735d36&"
import script from "./IconTikTokLight.vue?vue&type=script&lang=js&"
export * from "./IconTikTokLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports